import React from 'react';
import ReactDOM from 'react-dom/client';
import Article from './Article';
import './index.scss';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Article />
  </React.StrictMode>
);
